/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDiscountSplash } from './IDiscountSplash';
import {
    IDiscountSplashFromJSON,
    IDiscountSplashFromJSONTyped,
    IDiscountSplashToJSON,
} from './IDiscountSplash';
import type { LineItemSelectedVariantOption } from './LineItemSelectedVariantOption';
import {
    LineItemSelectedVariantOptionFromJSON,
    LineItemSelectedVariantOptionFromJSONTyped,
    LineItemSelectedVariantOptionToJSON,
} from './LineItemSelectedVariantOption';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * 
 * @export
 * @interface LineItemReturnModel
 */
export interface LineItemReturnModel {
    /**
     * 
     * @type {string}
     * @memberof LineItemReturnModel
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItemReturnModel
     */
    productUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItemReturnModel
     */
    parentId?: string;
    /**
     * 
     * @type {Price}
     * @memberof LineItemReturnModel
     */
    unitPrice?: Price;
    /**
     * 
     * @type {Price}
     * @memberof LineItemReturnModel
     */
    totalPrice?: Price;
    /**
     * 
     * @type {Price}
     * @memberof LineItemReturnModel
     */
    groupTotalPrice?: Price;
    /**
     * 
     * @type {string}
     * @memberof LineItemReturnModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItemReturnModel
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItemReturnModel
     */
    name?: string;
    /**
     * 
     * @type {Array<LineItemReturnModel>}
     * @memberof LineItemReturnModel
     */
    addons?: Array<LineItemReturnModel>;
    /**
     * 
     * @type {string}
     * @memberof LineItemReturnModel
     */
    googleProductCategory?: string;
    /**
     * 
     * @type {number}
     * @memberof LineItemReturnModel
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof LineItemReturnModel
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItemReturnModel
     */
    designer?: string;
    /**
     * 
     * @type {number}
     * @memberof LineItemReturnModel
     */
    sortOrder?: number;
    /**
     * 
     * @type {IDiscountSplash}
     * @memberof LineItemReturnModel
     */
    discountSplash?: IDiscountSplash;
    /**
     * 
     * @type {Array<LineItemSelectedVariantOption>}
     * @memberof LineItemReturnModel
     */
    variantOptions?: Array<LineItemSelectedVariantOption>;
}

/**
 * Check if a given object implements the LineItemReturnModel interface.
 */
export function instanceOfLineItemReturnModel(value: object): boolean {
    return true;
}

export function LineItemReturnModelFromJSON(json: any): LineItemReturnModel {
    return LineItemReturnModelFromJSONTyped(json, false);
}

export function LineItemReturnModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineItemReturnModel {
    if (json == null) {
        return json;
    }
    return {
        
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'productUrl': json['productUrl'] == null ? undefined : json['productUrl'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'unitPrice': json['unitPrice'] == null ? undefined : PriceFromJSON(json['unitPrice']),
        'totalPrice': json['totalPrice'] == null ? undefined : PriceFromJSON(json['totalPrice']),
        'groupTotalPrice': json['groupTotalPrice'] == null ? undefined : PriceFromJSON(json['groupTotalPrice']),
        'id': json['id'] == null ? undefined : json['id'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'name': json['name'] == null ? undefined : json['name'],
        'addons': json['addons'] == null ? undefined : ((json['addons'] as Array<any>).map(LineItemReturnModelFromJSON)),
        'googleProductCategory': json['googleProductCategory'] == null ? undefined : json['googleProductCategory'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'designer': json['designer'] == null ? undefined : json['designer'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'discountSplash': json['discountSplash'] == null ? undefined : IDiscountSplashFromJSON(json['discountSplash']),
        'variantOptions': json['variantOptions'] == null ? undefined : ((json['variantOptions'] as Array<any>).map(LineItemSelectedVariantOptionFromJSON)),
    };
}

export function LineItemReturnModelToJSON(value?: LineItemReturnModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'imageUrl': value['imageUrl'],
        'productUrl': value['productUrl'],
        'parentId': value['parentId'],
        'unitPrice': PriceToJSON(value['unitPrice']),
        'totalPrice': PriceToJSON(value['totalPrice']),
        'groupTotalPrice': PriceToJSON(value['groupTotalPrice']),
        'id': value['id'],
        'sku': value['sku'],
        'name': value['name'],
        'addons': value['addons'] == null ? undefined : ((value['addons'] as Array<any>).map(LineItemReturnModelToJSON)),
        'googleProductCategory': value['googleProductCategory'],
        'quantity': value['quantity'],
        'brand': value['brand'],
        'designer': value['designer'],
        'sortOrder': value['sortOrder'],
        'discountSplash': IDiscountSplashToJSON(value['discountSplash']),
        'variantOptions': value['variantOptions'] == null ? undefined : ((value['variantOptions'] as Array<any>).map(LineItemSelectedVariantOptionToJSON)),
    };
}

